import { render } from "./CompanyLogo.vue?vue&type=template&id=26502df2&scoped=true&ts=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=ts"
export * from "./CompanyLogo.vue?vue&type=script&lang=ts"

import "./CompanyLogo.vue?vue&type=style&index=0&id=26502df2&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26502df2"]])

export default __exports__